// extracted by mini-css-extract-plugin
export default {"materialBox":"material_materialBox__OfvHK","paramsBox":"material_paramsBox__hOW6d","copyBox":"material_copyBox__6uaYC","modalFormBox":"material_modalFormBox__Djbxa"};